import {
    STUDENT_AUDIT_CLOSE,
    STUDENT_AUDIT_HEADER_ERROR,
    STUDENT_AUDIT_HEADER_SUCCESS,
    STUDENT_AUDIT_OPEN,
    STUDENT_AUDIT_PHOTO_SUCCESS,
    STUDENT_AUDIT_PROGRAMS_ERROR,
    STUDENT_AUDIT_PROGRAMS_REQUEST,
    STUDENT_AUDIT_PROGRAMS_SUCCESS,
    STUDENT_AUDIT_SELECT_PROGRAM,
    STUDENT_AUDIT_TREE_ERROR,
    STUDENT_AUDIT_TREE_REQUEST,
    STUDENT_AUDIT_TREE_SUCCESS,
    STUDENT_AUDIT_WHAT_IF_ERROR,
    STUDENT_AUDIT_WHAT_IF_EXIT,
    STUDENT_AUDIT_WHAT_IF_REQUEST,
    STUDENT_AUDIT_WHAT_IF_SUCCESS,
} from './types';
import { sameProgramKeys } from './programKeys';

// Failures are stored flattened by auditFailureOf ({ status, code, message, ... }) so the page can word them.
export const initialState = {
    studentUID: null,
    generation: 0,
    selectionGeneration: 0,
    treeRequestId: null,
    programsRequestId: null,
    whatIfRequestId: null,
    header: null,
    headerError: null,
    photoUrl: null,
    programs: [],
    programsLoading: false,
    programsError: null,
    selectedKeys: null,
    tree: null,
    treeLoading: false,
    treeError: null,
    whatIf: { auditProgramID: null, tree: null, loading: false, error: null },
};

const forStudent = (state, action) => action.studentUID === state.studentUID;

const reduceTree = (state, action) => {
    switch (action.type) {
        case STUDENT_AUDIT_SELECT_PROGRAM:
            return { ...state, selectionGeneration: state.selectionGeneration + 1, selectedKeys: action.payload, tree: null, treeError: null, whatIf: initialState.whatIf };
        case STUDENT_AUDIT_TREE_REQUEST:
            return sameProgramKeys(action.keys, state.selectedKeys) ? { ...state, treeRequestId: action.requestId, treeLoading: true, treeError: null } : state;
        case STUDENT_AUDIT_TREE_SUCCESS:
            if (action.requestId !== undefined && state.treeRequestId !== action.requestId) return state;
            // A slow response for a program the user has already left is dropped.
            return sameProgramKeys(action.keys, state.selectedKeys) ? { ...state, tree: action.payload, treeLoading: false, treeError: null } : state;
        case STUDENT_AUDIT_TREE_ERROR:
            if (action.requestId !== undefined && state.treeRequestId !== action.requestId) return state;
            return sameProgramKeys(action.keys, state.selectedKeys) ? { ...state, treeLoading: false, treeError: action.payload } : state;
        default:
            return state;
    }
};

const reduceWhatIf = (state, action) => {
    switch (action.type) {
        case STUDENT_AUDIT_WHAT_IF_REQUEST:
            return { ...state, whatIfRequestId: action.requestId, whatIf: { auditProgramID: action.auditProgramID, tree: null, loading: true, error: null } };
        case STUDENT_AUDIT_WHAT_IF_SUCCESS:
            if (state.whatIf.auditProgramID !== action.auditProgramID || (action.requestId !== undefined && state.whatIfRequestId !== action.requestId)) return state;
            return { ...state, whatIf: { ...state.whatIf, tree: action.payload, loading: false, error: null } };
        case STUDENT_AUDIT_WHAT_IF_ERROR:
            if (state.whatIf.auditProgramID !== action.auditProgramID || (action.requestId !== undefined && state.whatIfRequestId !== action.requestId)) return state;
            return { ...state, whatIf: { ...initialState.whatIf, error: action.payload } };
        case STUDENT_AUDIT_WHAT_IF_EXIT:
            return { ...state, whatIf: initialState.whatIf };
        default:
            return state;
    }
};

const studentAuditReducer = (state = initialState, action) => {
    if (action.generation !== undefined && (action.generation !== state.generation || action.studentUID !== state.studentUID)) return state;
    if (action.selectionGeneration !== undefined && action.selectionGeneration !== state.selectionGeneration) return state;
    switch (action.type) {
        case STUDENT_AUDIT_OPEN:
            return { ...initialState, studentUID: action.studentUID, generation: state.generation + 1 };
        case STUDENT_AUDIT_CLOSE:
            return { ...initialState, generation: state.generation + 1 };
        case STUDENT_AUDIT_HEADER_SUCCESS:
            return forStudent(state, action) ? { ...state, header: action.payload, headerError: null } : state;
        case STUDENT_AUDIT_HEADER_ERROR:
            return forStudent(state, action) ? { ...state, headerError: action.payload } : state;
        case STUDENT_AUDIT_PHOTO_SUCCESS:
            return forStudent(state, action) ? { ...state, photoUrl: action.payload } : state;
        case STUDENT_AUDIT_PROGRAMS_REQUEST:
            return forStudent(state, action) ? { ...state, programsRequestId: action.requestId, programsLoading: true, programsError: null } : state;
        case STUDENT_AUDIT_PROGRAMS_SUCCESS:
            if (action.requestId !== undefined && state.programsRequestId !== action.requestId) return state;
            return forStudent(state, action) ? { ...state, programs: action.payload, programsLoading: false } : state;
        case STUDENT_AUDIT_PROGRAMS_ERROR:
            if (action.requestId !== undefined && state.programsRequestId !== action.requestId) return state;
            return forStudent(state, action) ? { ...state, programsLoading: false, programsError: action.payload } : state;
        default:
            return reduceWhatIf(reduceTree(state, action), action);
    }
};

export default studentAuditReducer;
